import { ICustomFlow } from '../../../interfaces/component-interfaces';

export const getFlowInfo = (flowName: string, agentConnect?: boolean): ICustomFlow | undefined => {
  /** For escalation event */
  if (!flowName || flowName === '') {
    if (agentConnect) return { agentConnect: true };
  }
  switch (flowName) {
    /** Order Selection */
    case 'orderSelection_orderTracking':
      return { flowType: 'orderTracking', flowStep: 'order_selection' };
    case 'orderSelection_cancellation':
      return { flowType: 'orderCancellation', flowStep: 'order_selection' };
    case 'orderSelection_lateOrder':
      return { flowType: 'orderReportProblem', flowStep: 'order_selection', additionalInfo: 'lateOrder' };
    case 'orderSelection_damagedOrder':
      return { flowType: 'orderReportProblem', flowStep: 'order_selection', additionalInfo: 'damagedOrder' };
    case 'orderSelection_orderNotReceived':
      return { flowType: 'orderReportProblem', flowStep: 'order_selection', additionalInfo: 'orderNotReceived' };
    case 'orderSelection_wrongOrder':
      return { flowType: 'orderReportProblem', flowStep: 'order_selection', additionalInfo: 'wrongOrder' };
    case 'orderSelection_missingProduct':
      return { flowType: 'orderReportProblem', flowStep: 'order_selection', additionalInfo: 'missingProduct' };

    case 'orderSelection_general':
      return { flowType: 'orderFlow', flowStep: 'order_selection' };

    /** Product Selection */
    case 'productSelection_orderTracking':
      return { flowType: 'orderTracking', flowStep: 'product_selection' };
    case 'productSelection_cancellation':
      return { flowType: 'orderCancellation', flowStep: 'product_selection' };
    case 'productSelection_lateOrder':
      return { flowType: 'orderReportProblem', flowStep: 'product_selection', additionalInfo: 'lateOrder' };
    case 'productSelection_damagedOrder':
      return { flowType: 'orderReportProblem', flowStep: 'product_selection', additionalInfo: 'damagedOrder' };
    case 'productSelection_orderNotReceived':
      return { flowType: 'orderReportProblem', flowStep: 'product_selection', additionalInfo: 'orderNotReceived' };
    case 'productSelection_wrongOrder':
      return { flowType: 'orderReportProblem', flowStep: 'product_selection', additionalInfo: 'wrongOrder' };
    case 'productSelection_missingProduct':
      return { flowType: 'orderReportProblem', flowStep: 'product_selection', additionalInfo: 'missingProduct' };

    case 'orderTracking':
      return { flowType: 'orderTracking', flowStep: 'tracking_response' };
    case 'moneyBackMode':
      return { flowType: 'orderCancellation', flowStep: 'cancellation_mode' };
    case 'cancellationConfirmation':
      return { flowType: 'orderCancellation', flowStep: 'cancellation_confirm' };
    case 'productsCancelled':
      return { flowType: 'orderCancellation', flowStep: 'products_cancelled' };
    case 'reportProblem':
      return { flowType: 'orderReportProblem', flowStep: 'problem_select' };
    case 'escalation':
      return { flowType: 'orderReportProblem', flowStep: 'escalation' };

    default:
      break;
  }
  return undefined;
};
